import styled from "styled-components";

export const StyledBoxContainer = styled.div`
    padding: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: calc(100vh - 80px);
`
